import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/styles/globals.css'
import { App } from '@/app/App'
import { saasRouter } from '@/app/router.saas'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App router={saasRouter} />
  </StrictMode>,
)
